import React, { useContext } from 'react';
import useMutation from '../../../../../../hooks/useMutation';
import {
  UserMutations,
  VerifyUserEmailResponse,
  VerifyUserEmailVariables,
} from '../../../../../../graphql/user.graphql';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { useToast } from '../../../../../../providers/ToastProvider';
import { t } from '../../../../../../types/translation/Translator';
import { ToastType } from '../../../../../components/Toast';
import { Button } from '../../../../../components/Button';
import { Surface } from '../../../../../components/Surface';
import { CompanyRoleAssignment } from '../../../../../../types/company_role_assignment';
import { UserContext } from '../../../../../../context/UserContext';

interface UserUpdateManagementEmailVerificationSectionProps {
  user: CompanyRoleAssignment;
}

export default function UserUpdateManagementEmailVerificationSection({
  user: role,
}: UserUpdateManagementEmailVerificationSectionProps) {
  const { showToast } = useToast();
  const { companyUsers } = useContext(UserContext);

  const [verifyEmail, { loading: verifyEmailLoading }] = useMutation<VerifyUserEmailResponse, VerifyUserEmailVariables>(
    UserMutations.verifyUserEmail,
    {
      variables: { id: role.id },
      onCompleted: response => {
        showToast({
          type: ToastType.success,
          title: t(TranslationKey.userSettingsManagementVerifyEmailSentToastTitle).singular.upper,
        });
      },
    },
  );

  const user = companyUsers.get(role.userId);
  if (!user) return null;

  return (
    <Surface>
      <div className='grid gap-4'>
        <div className='grid gap-2'>
          <p className='section-title'>{t(TranslationKey.userSettingsManagementVerifyUserEmailTitle).singular.upper}</p>
        </div>
        {user.verified ? (
          <p className='subtitle'>
            {t(TranslationKey.userSettingsManagementVerifyEmailAlreadyVerified).singular.upper}
          </p>
        ) : (
          <Button
            text={t(TranslationKey.userSettingsManagementVerifyUserEmailRequestAction).singular.upper}
            loading={verifyEmailLoading}
            disabled={user.verified}
            className='w-fit'
            onClick={() => verifyEmail()}
          />
        )}
      </div>
    </Surface>
  );
}
